<mat-spinner [diameter]="diameter" [strokeWidth]="2" color="black"></mat-spinner>